/* eslint-disable indent, react/prop-types, react/jsx-indent, react/jsx-indent-props */
import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router";
import {
  Container,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Alert,
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import API from "../Utility";
import Spinner from "react-bootstrap/Spinner";
import Table from "../Utility/Table";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { LinkContainer } from "react-router-bootstrap";
import EditableTextInput from "../EditableTextInput";
import { ThemedView } from "../Theme";
import ConfirmationModal from "../ConfirmationModal";
import EditGroupUsersForm from "./EditGroupUsersForm";

// Styles
import "./UserGroupsSingleView.scss";
import {
  FaRegTrashAlt,
  FaRegSave,
  FaPlus,
  FaEdit,
  FaTimes,
} from "react-icons/fa";

export default function UserGroupsSingleView({
  children,
  location,
  ...routeProps
}) {
  let { project, groupId } = useParams();

  const [groupData, setGroupData] = useState([]);
  const [groupUsersData, setGroupUsersData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [name, setName] = useState(groupData.name);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [editUsersModalShow, setEditUsersModalShow] = useState(false);
  const [deleteUserModalShow, setDeleteUserModalShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState();
  const [submitSuccess, setSubmitSuccess] = useState();
  const [submitting, setSubmitting] = useState();

  let history = useHistory();

  const cellFormatter = (cell) => {
    return (
      <div>
        <div className="float-left">{cell}</div>
        {(groupData && groupData.isUserControlled === true && (
          <Button
            style={{ minWidth: "auto" }}
            variant="outline-primary"
            size={"sm"}
            className="user-groups-single-view__remove-button clickable float-right"
          >
            <FaTimes />
          </Button>
        )) ||
          (groupData &&
            !groupData.isUserControlled === true &&
            tooltipsEnabled && (
              <OverlayTrigger
                placement={tooltipPlacement}
                overlay={
                  <Tooltip id="delete-tooltip-disabled">
                    <b>{tooltipTitle}</b>
                    <p>{tooltipMessage}</p>
                  </Tooltip>
                }
              >
                <div
                  className="clickable float-right"
                  style={{
                    cursor: "not-allowed",
                    color: "#343a40",
                    opacity: 0.65,
                  }}
                >
                  <FaTimes />
                </div>
              </OverlayTrigger>
            ))}
      </div>
    );
  };

  const rowClasses = "react-bootstrap-table__row";
  const columns = [
    {
      dataField: "displayName",
      text: "Users",
      formatter: (cell) => cellFormatter(cell),
    },
  ];
  const selectRow =
    groupData && groupData.isUserControlled === true
      ? {
          mode: "checkbox",
          clickToSelect: true,
          hideSelectColumn: true,
          selectColumnPosition: "right",
          onSelect: (row, isSelect, rowIndex, e) => {
            // console.log(row);
            setSelectedUser(row);
            setDeleteUserModalShow(true);
          },
        }
      : {
          mode: "checkbox",
          clickToSelect: false,
          hideSelectColumn: true,
          // nonSelectable: [0, 2, 4]
        };

  async function getGroupData(query) {
    setGroupData([]);
    setGroupUsersData([]);
    setIsLoading(true);
    const { users, name, isUserControlled, _id } = await API.get({
      url: query.url,
      params: query.params,
    });
    setIsLoading(false);
    setGroupData({ name, isUserControlled, _id });
    setGroupUsersData(users.filteredResults);
    setTotalSize(users.totalResultsCount);
  }

  useEffect(() => {
    async function initializeData() {
      await getGroupData({
        url: `/admin/${project}/groups/${groupId}`,
        params: {
          usersPage: 1,
          usersPageSize: 20,
          usersSortType: "name",
          usersSortDir: 1,
          usersNameMatch: null,
        },
      });
    }

    initializeData();
  }, []);

  const loading = () => {
    return groupData.length < 1 && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>No results</span>
      </div>
    );
  };

  const onTableChange = async (type, { sortField, sortOrder, data, page }) => {
    setCurrentPage(page);
    await getGroupData({
      url: `/admin/${project}/groups/${groupId}`,
      params: {
        usersPage: page,
        usersPageSize: 20,
        usersSortType: sortField,
        usersSortDir: 1,
        usersNameMatch: null,
      },
    });
  };

  const handleNameChange = (newName) => {
    if (newName !== groupData.name) {
      setName(newName);
      saveGroup(newName);
      // console.log("name changed to: ", newName);
    } else {
      setName(null);
      // console.log("name stayed as: ", newName);
    }
  };

  const saveGroup = async (newName) => {
    groupData.name = newName || name;
    await save({
      url: `/admin/${project}/groups/${groupId}`,
      data: groupData,
    });
  };

  async function save(query) {
    try {
      setSubmitting(true);
      const { name, isUserControlled, _id } = await API.put({
        url: query.url,
        data: query.data,
      });
      setGroupData({ name, isUserControlled, _id });
      setName(null);
      setSubmitting(false);
      setSubmitSuccess("Group name successfully updated.");
      setTimeout(() => {
        setSubmitSuccess();
      }, 5000);
    } catch (err) {
      setSubmitting(false);
      if (!err.response) {
        setSubmitError(err && err.message);
      } else {
        setSubmitError(
          err && err.response && err.response.data && err.response.data.message
        );
      }
      setTimeout(() => {
        setSubmitError();
      }, 5000);
    }
  }

  const deleteGroup = async () => {
    setDeleteModalShow(true);
  };

  const confirmDelete = async (event, exitValue) => {
    // console.log("confirmDelete: ", exitValue);
    if (exitValue === true) {
      await del({
        url: `/admin/${project}/groups/${groupId}`,
        data: groupData,
      });
    } else {
      setDeleteModalShow(false);
    }
  };

  async function del(query) {
    const response = await API.delete({
      url: query.url,
      data: query.data,
    });
    setDeleteModalShow(false);
    history.push(`/groups/${project}${response}`);
  }

  const editUsersToGroup = () => {
    setEditUsersModalShow(true);
  };

  const confirmEditUsers = (event, exitValue) => {
    // console.log("confirmEditUsers: ", exitValue);
    async function initializeData() {
      await getGroupData({
        url: `/admin/${project}/groups/${groupId}`,
        params: {
          usersPage: currentPage || 1,
          usersPageSize: 20,
          usersSortType: "name",
          usersSortDir: 1,
          usersNameMatch: null,
        },
      });
    }
    setaddUsersModalMessage({
      message: "",
      status: 0,
    });
    if (exitValue === true) {
      setEditUsersModalShow(false);
      initializeData();
    } else {
      setEditUsersModalShow(false);
    }
  };

  const [addUsersModalMessage, setaddUsersModalMessage] = useState({
    message: "",
    status: 0,
  });

  const addUsersToGroup = (event, response) => {
    if (response && response.modified && response.modified > 0) {
      confirmEditUsers(event, true);
      setaddUsersModalMessage({
        message: "Success: User(s) added to this group",
        status: 1,
      });
    } else if ((response && response.modified) || response.modified === 0) {
      // confirmEditUsers(event, false);
      setaddUsersModalMessage({
        message: "Error: User(s) already added to this group",
        status: 2,
      });
    } else {
      setaddUsersModalMessage({
        message: "Please select at least one user",
        status: 3,
      });
    }
  };

  const setEditUsersModalHTMLBody = () => {
    return (
      <EditGroupUsersForm
        project={project}
        group={groupData}
        responseMessage={addUsersModalMessage}
        onSubmit={(e, m) => addUsersToGroup(e, m)}
        onCancel={(event, exitValue) => confirmEditUsers(event, exitValue)}
      />
    );
  };

  const confirmUserDelete = async (event, exitValue) => {
    // console.log("confirmDelete: ", exitValue);
    if (exitValue === true) {
      await deleteUser({
        url: `/admin/${project}/groups/${groupId}/removeUser`,
        data: { user: selectedUser },
      });
    } else {
      setDeleteUserModalShow(false);
    }
  };

  async function deleteUser(query) {
    async function initializeData() {
      await getGroupData({
        url: `/admin/${project}/groups/${groupId}`,
        params: {
          usersPage: currentPage || 1,
          usersPageSize: 20,
          usersSortType: "name",
          usersSortDir: 1,
          usersNameMatch: null,
        },
      });
    }
    const response = await API.post({
      url: query.url,
      data: query.data,
    });

    if (response && response.modified > 0) {
      setDeleteUserModalShow(false);
      initializeData();
    } else {
      setDeleteUserModalShow(false);
    }
  }

  const tooltipsEnabled = true;
  const tooltipPlacement = "top";
  const tooltipTitle = "Action not allowed";
  const tooltipMessage = "This group is controlled by an external data feed";

  return (
    <div>
      <Row>
        <Col>
          <Breadcrumb as="nav" bsPrefix="breadcrumb ph-admin__breadcrumb">
            <LinkContainer to={`/groups/${project}`}>
              <Breadcrumb.Item bsPrefix="breadcrumb-item clickable">
                Groups
              </Breadcrumb.Item>
            </LinkContainer>
            <Breadcrumb.Item active>{groupData.name}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row className="justify-content-between">
        <Col md="auto" style={{ maxWidth: "58rem" }}>
          {!groupData.isUserControlled && (
            <h2>
              {groupData.name}
              {groupData.name && tooltipsEnabled && (
                <OverlayTrigger
                  placement={tooltipPlacement}
                  overlay={
                    <Tooltip id="delete-tooltip-disabled">
                      <b>{tooltipTitle}</b>
                      <p>{tooltipMessage}</p>
                    </Tooltip>
                  }
                >
                  <span
                    className="clickable ml-2"
                    style={{
                      cursor: "not-allowed",
                      color: "#343a40",
                      opacity: 0.65,
                    }}
                  >
                    <sup>
                      <small>
                        <FaEdit />
                      </small>
                    </sup>
                  </span>
                </OverlayTrigger>
              )}
            </h2>
          )}
          {groupData.isUserControlled && (
            <EditableTextInput
              name="groupName"
              type="text"
              value={groupData.name}
              editClassName="form-control"
              onNameChange={handleNameChange}
              maxWidth={20}
            />
          )}
          {submitting && (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}
          {submitError && <Alert variant={"danger"}>{submitError}</Alert>}
          {submitSuccess && <Alert variant={"success"}>{submitSuccess}</Alert>}
        </Col>
        <Col md="auto">
          {groupData.isUserControlled && (
            <>
              <Button
                className="float-right ml-2 mb-2"
                variant="outline-primary"
                onClick={deleteGroup}
              >
                <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}> Delete Group</span>
              </Button>
              <Button
                className="float-right mb-2"
                variant="outline-primary"
                onClick={editUsersToGroup}
              >
                <FaPlus style={{ verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}> Add User</span>
              </Button>
            </>
          )}
          {groupData.isUserControlled === false && tooltipsEnabled && (
            <>
              <OverlayTrigger
                placement={tooltipPlacement}
                overlay={
                  <Tooltip id="delete-tooltip-disabled">
                    <b>{tooltipTitle}</b>
                    <p>{tooltipMessage}</p>
                  </Tooltip>
                }
              >
                <span
                  className="d-inline-block float-right"
                  style={{ cursor: "not-allowed" }}
                >
                  <Button
                    disabled
                    style={{ pointerEvents: "none" }}
                    className="float-right ml-2 mb-2"
                    variant="outline-primary"
                    onClick={(e) => e.preventDefault()}
                  >
                    <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}>
                      {" "}
                      Delete Group
                    </span>
                  </Button>
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement={tooltipPlacement}
                overlay={
                  <Tooltip id="add-users-tooltip-disabled">
                    <b>{tooltipTitle}</b>
                    <p>{tooltipMessage}</p>
                  </Tooltip>
                }
              >
                <span
                  className="d-inline-block float-right mr-2"
                  style={{ cursor: "not-allowed" }}
                >
                  <Button
                    disabled
                    style={{ pointerEvents: "none" }}
                    className="float-right mb-2"
                    variant="outline-primary"
                    onClick={(e) => e.preventDefault()}
                  >
                    <FaPlus style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}> Add User</span>
                  </Button>
                </span>
              </OverlayTrigger>
            </>
          )}
          {/* {name && (
            <Button
              className="float-right mr-2"
              variant="outline-primary"
              onClick={saveGroup}
            >
              <FaRegSave />
            </Button>
          )} */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Table
            remote
            columns={columns}
            keyField={"_id"}
            data={groupUsersData}
            onTableChange={onTableChange}
            page={currentPage}
            totalSize={totalSize}
            noDataIndication={loading}
            rowClasses={rowClasses}
            selectRow={selectRow}
          />
        </Col>
      </Row>
      <ConfirmationModal
        title={groupData.name}
        body={
          <>
            <p>Are you sure you want to delete this group?</p>
          </>
        }
        show={deleteModalShow}
        confirmtext={"Delete"}
        onHide={(event, exitValue) => confirmDelete(event, exitValue)}
      />
      <ConfirmationModal
        title={groupData.name}
        custombody={setEditUsersModalHTMLBody()}
        show={editUsersModalShow}
        confirmtext={"Save"}
        onHide={(event, exitValue) => confirmEditUsers(event, exitValue)}
      />
      <ConfirmationModal
        title={groupData.name}
        body={
          <>
            <p>
              Are you sure you want to remove the following user from this
              group?
            </p>
            <p>
              <b>
                {selectedUser.displayName ||
                  selectedUser.email ||
                  selectedUser.username}
              </b>
            </p>
          </>
        }
        show={deleteUserModalShow}
        confirmtext={"Remove"}
        onHide={(event, exitValue) => confirmUserDelete(event, exitValue)}
      />
    </div>
  );
}
